import { AlertTriangle } from 'lucide-react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'

interface ApiErrorDisplayProps {
  message: string
}

export const ApiErrorDisplay = ({ message }: ApiErrorDisplayProps) => {
  return (
    <div className="container max-w-3xl mx-auto px-4 pb-4">
      <Alert variant="destructive">
        <AlertTriangle className="h-4 w-4" />
        <AlertTitle>Assistant Error</AlertTitle>
        <AlertDescription>{message}</AlertDescription>
      </Alert>
    </div>
  )
}
